import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguageFromURL, defaultLanguageCode } from '@/router';
import { resources } from './localisation/translations';
import { SUPPORTED_LANGUAGES } from './utils/constants';

// Import directly for debugging if needed
import './localisation/translations-feedback';

(async () => {
  await i18n.use(initReactI18next).init({
    resources: resources,
    lng: getLanguageFromURL(),
    fallbackLng: defaultLanguageCode,
    supportedLngs: SUPPORTED_LANGUAGES.map((lang) => lang.code),

    interpolation: {
      escapeValue: false,
    },
    // Add this to help debug
    debug: true,
  });
})();

export default i18n;
